/*
 * @Author: wzh
 * @LastEditTime: 2022-11-24 10:23:03
 * @Description: 弹框状态
 */
import { VuexModule, Module, Mutation } from "vuex-module-decorators";

@Module({ namespaced: true })
export default class ModalModule extends VuexModule {
	_isShow = false;

	get isShow() {
		return this._isShow;
	}

	@Mutation
	setIsShow(bool) {
		this._isShow = bool;
	}
}
